module.exports = __webpack_public_path__ + "img/Women’s Health.6eb41f52.jpg";